import type { RootState, SetState } from '../store';

export type DynamicOrderingSliceProps = {
    dynamicOrdering: {
        launchedGamesByZone: Record<string, string[]>;
        trackLaunchedGame: (zoneUid: string, gameUid: string) => void;
    };
};

export const dynamicOrderingSlice = ({ set }: SetState<RootState>): DynamicOrderingSliceProps => ({
    dynamicOrdering: {
        launchedGamesByZone: {},

        trackLaunchedGame: (zoneUid: string, gameUid: string) => {
            set(
                (state) => {
                    const current = state.dynamicOrdering.launchedGamesByZone[zoneUid] || [];
                    const filtered = current.filter((uid) => uid !== gameUid);
                    const updated = [...filtered, gameUid];

                    return {
                        dynamicOrdering: {
                            ...state.dynamicOrdering,
                            launchedGamesByZone: {
                                ...state.dynamicOrdering.launchedGamesByZone,
                                [zoneUid]: updated
                            }
                        }
                    };
                },
                false,
                'dynamicOrdering/trackLaunchedGame'
            );
        }
    }
});
